import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import _ from "lodash";
import SamplesModelDialog from "./SamplesModelDialog.vue";
import jslinq from "jslinq";
import hideMobileKeyboardOnReturn from "../plugins/utils"; // import {Waypoint} from 'vue-waypoint'

let ColoriFrontali = class ColoriFrontali extends Vue {
  constructor() {
    super(...arguments);
    this.noImageColor = [];
    this.ecoColors = false;
    this.searchQuery = "";
    this.category = [];
    this.animateColors = false;
    this.hoverWarning = false;
    this.showSampleDialog = false;
    this.giacWarning = false;
    this.giacWarningMessage = "";
  }

  async mounted() {
    await this.getColors();
  }

  hideMobileKeyboardOnReturn(e) {
    hideMobileKeyboardOnReturn(e);
  }

  get categories() {
    return jslinq(this.colori).select(c => c.Category).distinct().toList();
  }

  get filteredColors() {
    let q = this.searchQuery;
    let c = this.category;
    let result = this.colori;

    if (q) {
      result = result.filter(color => {
        return _.includes(color === null || color === void 0 ? void 0 : color.PLASTICA, q);
      });
    }

    if (!_.isEmpty(c)) {
      if (result) {
        result = result.filter(color => {
          return c.indexOf(color === null || color === void 0 ? void 0 : color.Category) >= 0;
        });
      }
    }

    if (this.ecoColors) {
      result = result.filter(color => {
        return color.U_THE_COLORE.indexOf("EP") >= 0;
      });
    }

    return _.difference(result, this.noImageColor);
  }

  get finitura() {
    return this.$store.state.configurator.finitura;
  }

  set finitura(f) {
    this.$store.commit("configurator/setFinishing", f);
  }

  get colore() {
    return this.$store.state.configurator.colore;
  }

  set colore(c) {
    if (parseInt(c.GiacIta) < 1) {
      this.giacWarning = true;
      this.giacWarningMessage = this.$t('message.Il_colore_{color}_è_esaurito,_data_di_arrivo:_{date}', {
        color: c.U_THE_COLORE,
        date: this.formatDate(new Date(c.ShipDateIta))
      }).toString();
    }

    this.$store.commit("configurator/setColore", c);
  }

  get colori() {
    return this.$store.state.configurator.frontali.colors;
  }

  get canOrderColorSample() {
    return this.$store.getters["canOrderColorSample"];
  }

  formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero based

    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  getColors() {
    return this.$store.dispatch("configurator/frontali/getColors");
  }

  colorImageUrl(colore) {
    if (colore && colore.Category != "MULTISTRATO") {
      return colore.imageUrl;
    }

    if (colore) {
      return colore.imageUrl;
    }

    return "";
  }

  isActive(c) {
    return this.colore == c;
  }

  removeCategoryItem(item) {
    _.pull(this.category, item);
  }

  noImageError(c) {
    this.noImageColor.push(c);
  }

  loadImageUrl(w) {
    let e = w.el;
    let src = w.el.dataset.src;

    if (w.going.toLowerCase() === "in") {
      e.src = src;
    }
  }

  onRevealSettingChanged(newVal) {
    if (newVal == "frontColor") {
      let self = this;
      this.animateColors = true;
      setTimeout(function () {
        self.animateColors = false;
        self.$emit("reset-setting-item");
      }, 2000);
    }
  }

  onColoreChanged(newVal) {
    let f = this.finitura == "S" ? "LUCIDO" : this.finitura == "N" ? "NATURALE" : "OPACO"; // @ts-ignore
    // eslint-disable-next-line no-undef

    ga("create", "UA-124639943-3", "auto", "frontaleglobal"); // @ts-ignore
    // eslint-disable-next-line no-undef

    ga("frontaleglobal.send", "event", "frontale", "setColore", newVal.U_THE_COLORE + " - " + f);
  }

  onFinituraChanged(newVal) {
    let f = newVal == "S" ? "LUCIDO" : newVal == "N" ? "NATURALE" : "OPACO"; // @ts-ignore
    // eslint-disable-next-line no-undef

    ga("create", "UA-124639943-3", "auto", "frontaleglobal"); // @ts-ignore
    // eslint-disable-next-line no-undef

    ga("frontaleglobal.send", "event", "frontale", "setColore", this.colore.U_THE_COLORE + " - " + f);
  }

};

__decorate([Prop({
  default: false
})], ColoriFrontali.prototype, "darkTheme", void 0);

__decorate([Prop({
  default: false
})], ColoriFrontali.prototype, "isOpen", void 0);

__decorate([Prop({
  default: false
})], ColoriFrontali.prototype, "revealSetting", void 0);

__decorate([Watch("revealSetting")], ColoriFrontali.prototype, "onRevealSettingChanged", null);

__decorate([Watch("colore")], ColoriFrontali.prototype, "onColoreChanged", null);

__decorate([Watch("finitura")], ColoriFrontali.prototype, "onFinituraChanged", null);

ColoriFrontali = __decorate([Component({
  components: {
    SamplesModelDialog
  },
  filters: {
    upper(val) {
      return _.upperCase(val);
    },

    capitalize: str => {
      return _.capitalize(str);
    }
  }
})], ColoriFrontali);
export default ColoriFrontali;